const GroupNoteIdentifier = ({  handleViewGroupNote, isGroupNote , customTemplateData, showGroupNote}) => {
    return (
        <div>
            {customTemplateData?.[0]?.Data[0]?.IsGroupEncounter === 'true'  && !showGroupNote ?
                <div className="p-1 bg-gc-thearpy-note d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-1">
                        <span className="fs-14 icon-question blue-quetion">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </span>
                        <p className='text text-black'>This encounter was created from a Group session.</p>
                    </div>

                    <div className="d-flex align-items-center gap-1 cursor-pointer user-select-none">
                        <p className='heading fs-11 validate-color' onClick={handleViewGroupNote}>
                            {isGroupNote ? 'View Individual Note' : 'View Group Note'}
                        </p>
                        <i className="icon-icon-arrow-top-right fs-9 blue-icon"></i>
                    </div>
                </div>
                : null}
        </div>
    )
}

export default GroupNoteIdentifier